import { FC } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TwoColumn from 'components/TwoColumn';
import TextFieldSkeleton from 'components/TextFieldSkeleton';

type Props = {
  sections?: number;
  fields?: number;
};

const FormSkeleton: FC<Props> = ({ sections = 2 }) => (
  <>
    {Array(sections)
      .fill(0)
      .map((_, i) => (
        <Box key={i} sx={{ mb: 2 }}>
          <Accordion expanded={true}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>
                <Skeleton width={150} height="2em" />
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Stack spacing={4}>
                <TextFieldSkeleton />
                <TextFieldSkeleton />

                <TwoColumn
                  left={<TextFieldSkeleton />}
                  right={<TextFieldSkeleton />}
                />

                <TwoColumn
                  left={<TextFieldSkeleton />}
                  right={<TextFieldSkeleton />}
                />
              </Stack>
            </AccordionDetails>
          </Accordion>
        </Box>
      ))}
  </>
);

export default FormSkeleton;
